const ADMIN_FAVICON = "/lams_logo.png";
const DEFAULT_FAVICON = "/logo.jpg";

export function applyFaviconForPath(pathname: string) {
  const href = pathname.startsWith("/admin") ? ADMIN_FAVICON : DEFAULT_FAVICON;
  const link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (link && link.href.replace(window.location.origin, "") !== href) {
    link.href = href;
  }
}
